import axios from 'axios';

const apiInstance = axios.create({
    baseURL: '/api/',
    withCredentials: true,
    timeout: 5000, // timeout after 5 seconds
    headers: {
        Accept: 'application/json',
    },
});

export default apiInstance;
